import { render, staticRenderFns } from "./TextareaField.vue?vue&type=template&id=3aa59144&scoped=true"
import script from "./TextareaField.vue?vue&type=script&lang=js"
export * from "./TextareaField.vue?vue&type=script&lang=js"
import style0 from "./TextareaField.vue?vue&type=style&index=0&id=3aa59144&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa59144",
  null
  
)

export default component.exports